import React, { useState, useRef, useEffect } from 'react';
import styles from './MonthYearPicker.module.css';

const MONTHS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export default function MonthYearPicker({ value, onChange, placeholder = 'Seleccionar mes y año' }) {
  const [open, setOpen] = useState(false);
  const [viewYear, setViewYear] = useState(value?.year ?? new Date().getFullYear());
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Sync viewYear if value changes externally
  useEffect(() => {
    if (value?.year) setViewYear(value.year);
  }, [value?.year]);

  const handleMonthClick = (monthIndex) => {
    onChange({ month: monthIndex + 1, year: viewYear });
    setOpen(false);
  };

  const displayValue = value
    ? `${MONTHS[value.month - 1]} ${value.year}`
    : placeholder;

  return (
    <div className={styles.wrapper} ref={ref}>
      <button
        type="button"
        className={`${styles.trigger} ${!value ? styles.placeholder : ''}`}
        onClick={() => setOpen(v => !v)}
        aria-haspopup="true"
        aria-expanded={open}
      >
        <span>{displayValue}</span>
        <svg
          width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
          style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div className={styles.popup}>
          <div className={styles.yearNav}>
            <button type="button" onClick={() => setViewYear(y => y - 1)} aria-label="Año anterior">‹</button>
            <span>{viewYear}</span>
            <button type="button" onClick={() => setViewYear(y => y + 1)} aria-label="Año siguiente">›</button>
          </div>
          <div className={styles.monthGrid}>
            {MONTHS.map((m, i) => {
              const isSelected = value?.month === i + 1 && value?.year === viewYear;
              return (
                <button
                  key={m}
                  type="button"
                  className={`${styles.monthBtn} ${isSelected ? styles.selected : ''}`}
                  onClick={() => handleMonthClick(i)}
                >
                  {m.slice(0, 3)}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
